import { createThemeOptions } from '@Src/styles/theme';
import type React from 'react';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  lighten,
} from '@mui/material/styles';

type ThemeProviderProps = {
  children: React.ReactNode;
  primaryColor?: string;
  primaryFont?: string;
  secondaryFont?: string;
};

const v2DefaultPrimaryColour = '#2D55A6';

const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  primaryColor = v2DefaultPrimaryColour,
  primaryFont = 'Roboto',
  secondaryFont = 'sans-serif',
}) => {
  const lightestColor = lighten(primaryColor, 0.9);
  const themeOptions = createThemeOptions({
    lightestColor,
    primaryColor,
    primaryFont,
    secondaryFont,
  });

  const theme = createTheme(themeOptions);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
